import {Map, useYMaps, YMaps} from '@pbe/react-yandex-maps';
import {IconCar, IconTrain} from 'components/icons';
import {Layout} from 'components/layout';
import React, {useEffect, useLayoutEffect, useState} from 'react';
import {MapRoutesItem} from '../map-routes-item/map-routes-item';
import {cn} from 'lib/utils';

interface TransportItem {
  value: string;
  label: string;
  icon: React.ReactNode;
  map: string;
}

const transportList: TransportItem[] = [
  {value: 'car', label: 'На автомобиле', icon: <IconCar/>, map: '20 минут от МКАД'},
  {
    value: 'train',
    label: 'Наземное метро МЦД-4',
    icon: <IconTrain/>,
    map: 'От станции «Санино» 9 минут на автобусе № 245 до остановки «Усадьба Крекшино».'
  },
  // {value: 'bus', label: 'На автобусе', icon: <IconBus/>, map: ''},
];

// Примерные точки отправления (для демонстрации)
const routesFrom: Record<string, number[]> = {
  car: [55.700116, 37.520203],
  train: [55.607351, 37.144470],
  // bus: [55.670715, 37.014444],
};

const destination = [55.596852, 37.114715]; // Пока временно

const YMapWithRoute = ({transport}: { transport: string }) => {
  const ymaps = useYMaps(['MultiRouter']);
  const mapRef = React.useRef<any>(null); // можно типизировать как Map, если надо

  useEffect(() => {
    if (!ymaps || !mapRef.current) return;

    const from = routesFrom[transport];
    const to = destination;

    const multiRoute = new ymaps.multiRouter.MultiRoute(
      {
        referencePoints: [from, to],
        params: {
          routingMode: transport === 'car' ? 'auto' : 'masstransit',
        },
      },
      {
        boundsAutoApply: true,
        routeStrokeColor: '#007BFF',
        routeStrokeWidth: 4,
      }
    );

    // Очищаем старые объекты и добавляем новый маршрут
    mapRef.current.geoObjects.removeAll();
    mapRef.current.geoObjects.add(multiRoute);
  }, [ymaps, transport]);

  return (
    <Map
      defaultState={{
        center: destination,
        zoom: 10,
        controls: ['zoomControl'],
      }}
      width="100%"
      height="430px"
      modules={['multiRouter.MultiRoute']}
      instanceRef={mapRef}
    />
  );
};

export const MapRoutes = () => {
  const [currentTab, setCurrentTab] = useState<TransportItem>(transportList[0]);
  const [iframe, setIframe] = useState("https://yandex.ru/map-widget/v1/-/CHc7ICO0");

  useLayoutEffect(() => {
    if (currentTab.value === "car") setIframe("https://yandex.ru/map-widget/v1/-/CHc7ICO0");
    if (currentTab.value === "train") setIframe("https://yandex.ru/map-widget/v1/-/CHc7MBMT");
  }, [currentTab.value])


  return (
    <section id='routes' className="font-open-sans mt-[100px]">
      <Layout.Container>
        <div className="px-[33px]">
          <h3 className="uppercase font-bold text-[32px] text-plt-black text-center">
            Схема проезда
          </h3>

          <div
            className={cn("relative z-10 grid gap-8 px-[150px] mt-10 screen-1150:px-[50px] screen-800:px-3 screen-600:grid-cols-1 grid-cols-2", `${transportList.length}`)}>
            {transportList.map((transport) => (
              <MapRoutesItem
                key={transport.value}
                transport={transport}
                currentTab={currentTab}
                setCurrentTab={setCurrentTab}
              />
            ))}
          </div>

          <div
            className="mt-[-50px] screen-600:mt-5 h-[630px] w-full rounded-[40px] overflow-hidden relative z-0 ti_map">
            <YMaps
              query={{
                lang: 'ru_RU',
                apikey: '7f728e69-0815-4485-91dc-73751b2c3c37', // API ключ карт
              }}
            >
              <YMapWithRoute transport={currentTab.value}/>
            </YMaps>
            <iframe className='' style={{position: "relative"}} src={iframe} width="100%" height="100%" frameBorder="1"
                    allowFullScreen></iframe>
          </div>

          <p className="mt-4 text-center font-semibold text-xl screen-600:font-normal">
            Возможность выезда на МКАД по двум шоссе: Минское и Киевское
          </p>
        </div>
      </Layout.Container>
    </section>
  );
};
